import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import ModuleQuestion from "../../components/ModuleQuestion";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.4.8 Practice Case 6
            </h1>
            <p className="me-4">Estimated time to complete: 5 minutes</p>
          </section>
          <ModuleQuestion
            correctAnswer="B"
            assessmentName="practice_case_6"
            videoTranscript={
              <>
                <p>
                  <strong>AUDIO</strong>
                  <br />
                  VO: (FEMALE)
                  <br />
                </p>
                <p>
                  This is Practice Case Number 6. This is a negative case. The
                  size and contrast have already been adjusted. Starting at the
                  bottom of the brain and moving superiorly, we immediately
                  identify two areas of intense activity, located here and here.
                  This activity is within the bone and outside of the brain, but
                  may be distracting as you review the images. As you continue
                  to move superiorly, we identify a second area of intense
                  uptake, located here. The accompanying sagittal and coronal
                  views also show this uptake to be located posteriorly.
                  Utilizing the accompanying fused images, it is clear that this
                  activity is located within the bone. Returning to the PET
                  images and scrolling superiorly, we enter into the cerebellum,
                  where the normal gray-white contrast for this patient can be
                  seen. As we continue moving superiorly, we can see the
                  overlying occipital lobe here and here, and as we continue to
                  move upwards, normal gray-white contrast and white matter
                  tracts can be seen on the left-hand side. This pattern
                  continues to be seen even more superiorly here. However, on
                  the right-hand side, a large area of abnormality can be seen
                  here. Utilizing the accompanying PET-CT fused images, it is
                  clear that this large, region of decreased tracer uptake
                  corresponds to a large region of encephalomalacia involving
                  the right side of the brain. This is due to an old stroke in
                  the right middle cerebral artery distribution. Returning to
                  the PET images once again, it is clear that a white matter
                  tract is not identifiable on the right-hand side. gray-white
                  contrast cannot be assessed because the stroke resulted in
                  loss of brain parenchyma in this region (encephalomalacia). In
                  the peri-stroke region there is reduced gray-white contrast as
                  the result of decreased white matter activity not secondary to
                  increased gray matter activity.
                </p>

                <p>
                  Continuing upwards, we enter into the frontal cortices. Normal
                  gray-white contrast can be seen on the left-hand side. The
                  normal concave pattern, seen on the left-hand side, which is
                  typical of a negative scan, is not seen on the right-hand
                  side, secondary to the stroke. In addition, gray-white
                  contrast can be seen extending throughout the frontal
                  cortices, and white matter tracts are clearly identifiable as
                  we enter the parietal lobes. This pattern is only seen on the
                  left- hand side, however. On the right-hand side, white matter
                  tracts are not identifiable, and as we continue upwards, white
                  matter tracts continue to not be seen on the right-hand side.
                  On the left-hand side, white matter tracts are easily
                  identifiable through the top of the brain. So although there
                  is reduced gray-white contrast in the areas near the stroke,
                  this appears to be due to a reduction of white matter uptake,
                  rather than an increase in gray matter uptake. This should not
                  be confused with the type of decreased gray-white contrast
                  associated with amyloid deposits, in which the increase in
                  gray matter uptake causes the reduction of contrast. A lack of
                  any significant reduction of gray-white contrast in at least
                  two areas of the brain makes this a negative study indicating
                  sparse or no amyloid neuritic plaques.
                </p>
              </>
            }
            previousLesson="/module-2/module-2-4-7"
            nextLesson="/module-2/module-2-4-9"
            iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_756057753&entry_id=1_5xre8jru&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
            questionType="practice"
            videoId="1_5xre8jru"
          />
        </main>
      </div>
    </div>
  );
};

export default Module_2_1_1;
